import Swiper, { Navigation, Pagination } from 'swiper';

export default () => {
    Swiper.use([Navigation, Pagination]);

    let moduleSlider = new Swiper('.js-bigMedia-slider', {
        slidesPerView: 1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    let bigImageText = new Swiper('.js-bigImageText-slider', {
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}